import { Col, Form, Grid } from "antd";
import { useTranslation } from "react-i18next";
import {
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../../../components";
import { InputRequired } from "../../../../../../validations/validations";
import { FilterProps } from "../../data";

const OtherFilter: React.FC<FilterProps> = ({
  form,
  params,
  setParams,
  showHalfDaySelector,
  setShowHalfDaySelector,
  studentLimit,
  setStudentLimit,
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <>
      <Col
        span={
          screens.lg
            ? showHalfDaySelector
              ? 5
              : 6
            : showHalfDaySelector
            ? 12
            : 24
        }
      >
        <Form.Item
          style={{ marginBottom: 0 }}
          name={"locations"}
          label={screens.lg ? t("home.searchbar.resort.title") : ""}
          rules={[InputRequired(t, "home.searchbar.resort.title")]}
        >
          <ResortDropdown
            form={form}
            setShowHalfDaySelector={setShowHalfDaySelector}
            setStudentLimit={setStudentLimit}
          />
        </Form.Item>
      </Col>
      {showHalfDaySelector && (
        <Col span={screens.lg ? 5 : 12}>
          <Form.Item
            style={{ marginBottom: 0 }}
            name={"session_type"}
            label={screens.lg ? t("normal.sessionType") : ""}
            rules={[InputRequired(t, "normal.sessionType")]}
          >
            <SessionTypeSelector form={form} />
          </Form.Item>
        </Col>
      )}
      <Col span={screens.lg ? (showHalfDaySelector ? 5 : 6) : 12}>
        <Form.Item
          style={{ marginBottom: 0 }}
          name={"skill_type"}
          label={screens.lg ? t("normal.skill.title") : ""}
          rules={[InputRequired(t, "normal.skill.title")]}
        >
          <SkillSelector form={form} />
        </Form.Item>
      </Col>
      <Col span={screens.lg ? (showHalfDaySelector ? 5 : 6) : 12}>
        <Form.Item
          name={"count"}
          label={screens.lg ? t("normal.count.title") : ""}
          style={{ marginBottom: 0 }}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  Number(getFieldValue("adults")) === 0 &&
                  Number(getFieldValue("kids")) === 0
                )
                  return Promise.reject(
                    new Error(
                      t("form.required", { name: t("normal.count.title") })
                    )
                  );
                return Promise.resolve();
              },
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  Number(getFieldValue("adults")) +
                    Number(getFieldValue("kids")) >
                  studentLimit
                ) {
                  return Promise.reject(
                    new Error(
                      t("home.filter.count.error", { limit: studentLimit })
                    )
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <CountDropdown
            form={form}
            params={params}
            setParams={setParams}
            studentLimit={studentLimit}
          />
        </Form.Item>
        <Form.Item hidden name={"adults"} />
        <Form.Item hidden name={"kids"} />
      </Col>
    </>
  );
};

export default OtherFilter;
